const STOP_WORDS = new Set([
  "a", "an", "the", "and", "or", "but", "in", "on", "at", "to", "for", "of", "with",
  "by", "from", "as", "is", "are", "was", "were", "be", "been", "being", "have", "has",
  "had", "do", "does", "did", "will", "would", "could", "should", "may", "might", "can",
  "this", "that", "these", "those", "it", "its", "i", "you", "he", "she", "we", "they",
  "my", "your", "our", "their", "me", "him", "her", "us", "them", "what", "which", "who",
  "whom", "whose", "where", "when", "why", "how", "about", "into", "over", "after",
  "before", "between", "through", "during", "above", "below", "up", "down", "out", "off",
  "than", "too", "very", "just", "also", "not", "no", "nor", "so", "if", "then", "than",
]);

export const tokenize = (text = "") =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9+#.\-/\s]/g, " ")
    .split(/\s+/)
    .map((token) => token.trim())
    .filter((token) => token.length > 1 && !STOP_WORDS.has(token));
